import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { createDeskTodo } from "@/shared/api/desk-todos";
import { notify } from "@/shared/feedback/notify";
import {
  remindFromDocLinkPath,
  remindFromDocTitle,
  type RemindFromDocKind,
} from "./remind-from-doc-math";

/** Add this doc to personal My todos — plan/50 C. */
export function RemindMeButton(props: {
  companySlug: string;
  kind: RemindFromDocKind;
  docId: string;
  docNumber: string;
  partyName?: string | null;
  disabled?: boolean;
}) {
  const qc = useQueryClient();
  const mut = useMutation({
    mutationFn: () =>
      createDeskTodo(props.companySlug, {
        title: remindFromDocTitle({
          docNumber: props.docNumber,
          partyName: props.partyName,
        }),
        linkPath: remindFromDocLinkPath({
          companySlug: props.companySlug,
          kind: props.kind,
          docId: props.docId,
        }),
      }),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: ["deskTodos", props.companySlug],
      });
      notify.success("Added to My todos");
    },
    onError: (err) => {
      notify.error(
        err instanceof Error ? err.message : "Could not add reminder",
      );
    },
  });

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      disabled={props.disabled || mut.isPending}
      pending={mut.isPending}
      onClick={() => mut.mutate()}
    >
      Remind me
    </Button>
  );
}
